import { FC, useState, useMemo, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeContext } from './shared/contexts';
import { ThemeProvider } from "@mui/material/styles";
import Navbar from './components/Navbar';
import './App.css';
import {
  PaletteMode,
  createTheme,
  useMediaQuery,
  CssBaseline,
  ThemeOptions,
} from "@mui/material";
import { getDesignTokens } from "./shared/colorTheme";

import Home from './pages/home';
import About from './pages/about';

const App: FC = () => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [mode, setMode] = useState<PaletteMode>(
    prefersDarkMode ? "dark" : "light"
  );

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  useEffect(() => {
    if (mode === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [mode]);

  const theme = useMemo(
    () => createTheme(getDesignTokens(mode) as ThemeOptions),
    [mode]
  );

    return (
      <ThemeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
            <BrowserRouter>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
              </Routes>
            </BrowserRouter>
          </ThemeProvider>
        </ThemeContext.Provider>
    );
  };
  
  export default App;
